<template>
  <div
    v-if="!timeUp"
    id="countdown-popover-target"
    class="countdown-wrapper">
    <div class="countdown-opacity-background"/>
    <div class="countdown-time flex center-all">
      <SBIcon
        :icon="SBIconList.CLOCK"
        :color="SBColors.blackUltralight"
        :size="12"
        class="mr-1" />
      {{ timeLeft }} left to respond
    </div>

    <b-popover
      target="countdown-popover-target"
      triggers="hover"
      placement="top">
      <div>
        <h1>WhatsApp 24 hours window</h1>
        <p>Based on WhatsApp Business Policies, if more than 24 hours have passed from the last message sent by the contact, you may only follow up by sending an approved WhatsApp Message Template.</p>
        <p>Learn more about WhatsApp Business Policies <a href="https://www.whatsapp.com/legal/business-policy/" target="_blank">here</a>.</p>
      </div>
    </b-popover>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import moment from 'moment';

import { doubleDigit } from '@/helpers/numberFormat';
import SBIcon from '@/components/common/Icon';
import SBColors from '@/helpers/lists/colors';
import SBIconList from '@/helpers/lists/sb-icon-list';

export default {
  name: 'ConversationOpenedCountdown',
  components: {
    SBIcon,
  },
  data() {
    return {
      timeLeft: 'Checking time...',
      timeInterval: null,
      timeUp: true,
      initializing: true,
      SBColors,
      SBIconList,
    };
  },
  computed: {
    ...mapGetters({
      activeConversation: 'chat/activeConversation',
    }),
  },
  watch: {
    activeConversation() {
      this.countdown();
    },
  },
  mounted() {
    this.timeInterval = setInterval(this.countdown, 1000);
  },
  beforeDestroy() {
    clearInterval(this.timeInterval);
  },
  methods: {
    /** Checks the time difference between now and last inbound message date. */
    countdown() {
      const lastInboundDate = this.countdownFrom ? this.countdownFrom : this.activeConversation.inbound_sent_at;
      // Only calculate when last inbound message is receved not more than 24h ago
      if (lastInboundDate && this.$moment().diff(this.$moment(false, false).unix(lastInboundDate), 'days') === 0) {
        const elapsedSeconds = this.$moment().diff(this.$moment(false, false).unix(lastInboundDate), 'seconds');
        const remainingSeconds = 86400 - elapsedSeconds; // One day in seconds - elapsed seconds
        const duration = moment.duration(remainingSeconds, 'seconds');
        if (remainingSeconds < 60) {
          this.timeLeft = `${duration.seconds()}s`;
        } else if (remainingSeconds < 3600) { // This is the last hour countdown
          this.timeLeft = `${duration.minutes()}m`;
        } else { // if not last hour then just show hours left
          // We need to add 1 hour because we need to ceil it to a higher value.
          // e.g. When user sends a message the counter will have a value of 23min59sec. Since we only wan't to see the hours we need to see 24.
          // e.g.2 When time left is 1h 1min we would show 1 and when it gets below 1h we show minute counter. It feels wrong. It shoud show 2h when counter is at 1h 1min so it can show the minute counter when it gets below 1h.
          this.timeLeft = `${duration.hours() + 1}h`;
        }
        this.timeUp = false;
      } else {
        // More than a day passed... just fix the countdown to zero
        this.timeLeft = 'Session expired';
        this.timeUp = true;
      }
      this.initializing = false;
    },
  },
};
</script>

<style lang="scss" scoped>
  .countdown-wrapper {
    position: absolute;
    bottom: 2px;
    right: 18px;
    backdrop-filter: blur(15px);
    border-radius: 10px;
    background-color: $white; // coment this line to bring the blurred transparency back
  }

  .countdown-opacity-background {
    position: absolute;
    background-color: $white;
    opacity: 0.7;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    border-radius: 10px;
  }

  .countdown-time {
    position: relative;
    padding: 4px 8px;
    font-size: 12px;
    font-weight: 500;
    color: $blackUltralight;
  }
</style>
